'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { PageContext } from './context/page-context';
import { pageBreadcrumbRecipe } from './styles/page-breadcrumb.styles';
import type { PageBreadcrumbPropsInterface } from './types/page-breadcrumb.types';

/**
 * The page breadcrumb is used for navigational elements preceding the page title.
 *
 * @since 8.15.0
 */
export const PageBreadcrumb = forwardRef<HTMLDivElement, PageBreadcrumbPropsInterface>(
  (props: PageBreadcrumbPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, fluid, ...rest } = props;
    const context = useContext(PageContext);

    const styles = css(pageBreadcrumbRecipe.raw({ fluid: fluid ?? context.fluid }), cssProp);

    const Component = asChild ? Slot : 'div';

    return (
      <Component
        data-c11n-component="Page.Breadcrumb"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

PageBreadcrumb.displayName = 'Page.Breadcrumb';
